const fetchSearchResults = async (query, terms = true, maxResults = 4) => {
	try {
		const response = await fetch(`/api/search?q=${query}&terms=${terms}&maxResults=${maxResults}`);

		if (!response.ok) {
			throw new Error(`Error: ${response.status}`);
		}

		const data = await response.json();
		return data;
	} catch (error) {
		console.error("An error occurred while fetching the search results:", error);
		throw error;
	}
};

export default fetchSearchResults;
